import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import "./Dashboard.css";
import profile from "../assets/images/profile.png";
import banner from "../assets/images/banner.png";
import fundamentals from "../assets/images/fundamentals-icon.png";
import email from "../assets/images/email-icon.png";

const CyberAwarenessIntroDashboard = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({ first_name: "", last_name: "", username: "", score: 0, rank: 4, completion: "10%", days: 0 });
  const rawUserId = localStorage.getItem("userId");
  const userId = rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;
  console.log("Dohvaćeni userId:", userId);

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token nije pronađen, preusmjeravanje na login...");
        navigate("/login");
        return;
      }

      try {
        const response = await API.get("/user/userD"); // Ispravljena ruta
        const data = response.data?.data?.[0];

        if (!data) {
          console.error("Greška: Nema podataka o korisniku");
          return;
        }

        setUserData((prevData) => ({
          ...prevData,
          first_name: data?.first_name || "N/A",
          last_name: data?.last_name || "N/A",
          username: data?.username || "N/A",
          rank: data?.rank || 4,
          completion: data?.completion || "10%",
        }));
      } catch (error) {
        console.error("Greška pri dohvaćanju korisničkih podataka:", error);
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchUserScore = async () => {
      if (!userId) {
        console.error("Greška: userId je null ili nije postavljen.");
        return;
      }
      try {
        const scoreResponse = await API.get(`/module/score/${userId}`);
        const userScore = scoreResponse.data[0]?.score || 0;

        setUserData((prevData) => ({
          ...prevData,
          score: userScore,
        }));
      } catch (error) {
        console.error("Greška pri dohvaćanju score-a:", error);
      }
    };

    if (userId) {
      fetchUserScore();
    }
  }, [userId]);

  useEffect(() => {
    const startDate = new Date("2025-12-12"); // Postavi početni datum
    const currentDate = new Date(); // Trenutni datum

    // Izračunaj razliku u danima samo jednom prilikom mountanja komponente
    const timeDifference = startDate - currentDate; // Razlika u milisekundama
    const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24)); // Pretvori u dane

    setUserData((prevData) => ({
      ...prevData,
      days: daysRemaining, // Postavi preostale dane
    }));
  }, []); // Ovaj useEffect se pokreće samo pri mountanju komponente

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const modules = [
    { title: "Cyber Awareness Personal Free", xp: 150, image: fundamentals },
    { title: "Cyber Awareness Business Free", xp: 150, image: email }, //doce slika
   
  ];

  return (
    <div className="dashboard-container">
      <div className="main-content">
        <div className="header-banner">
          <img src={banner} alt="Banner" className="banner-img" />
        </div>

        <h3>Training Modules</h3>

        <div className="modules-grid">
          {modules.map((module, index) => (
            <div
              key={index}
              className="module-card"
              onClick={() => {
                if (module.title === "Cyber Awareness Personal Free") {
                  navigate("/personal-intro");
                }
                if (module.title === "Cyber Awareness Business Free") {
                  navigate("/business-intro");
                }
              }}
              style={
                module.title === "Cyber Awareness Personal Free" ||
                  module.title === "Cyber Awareness Business Free"
                
                  ? { cursor: "pointer" }
                  : {}
              }
            >
              <div className="module-card-content">
                <img src={module.image} alt={module.title} className="module-image" />
                <h4>{module.title}</h4>
                <p>{module.xp} XP</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar">
        <div className="profile">
          <img src={profile} alt="Profile" className="profile-img" />
          <h4>{userData.first_name} {userData.last_name}</h4>
          <p>@{userData.username}</p>
        </div>
        <div className="profile-info">
          <div className="profile-info-header">
            <h4>Profile Info</h4>
            <p
              className="see-all"
              onClick={() => navigate("/user-profile")}
            >
              See All
            </p>
          </div>
          <div className="info-item"><span>🏆 Rank:</span> {userData.rank}</div>
          <div className="info-item"><span>💡 Total score:</span> {userData.score}</div>
          <div className="info-item"><span>❌ Completion:</span> {userData.completion}</div>
          <div className="info-item"><span>📅 Days:</span> {userData.days}</div>
        </div>
        <div className="logout-container">
          <button onClick={handleLogout} className="logout-btn">Log out</button>
        </div>
      </div>
    </div>
  );
};

export default CyberAwarenessIntroDashboard;